import { makeStyles } from "@fluentui/react-components";
import { TimePicker } from "@fluentui/react-timepicker-compat";
import { CommonInfo } from "../../CommonData/Config";
import dayjs from 'dayjs';
import moment from "moment";

type RXTimePickerProps = {
    theme: string;
    value: string;
    bookingDate: Date;
    defaultTime: Date;
    timeInterval?: number;
    onTimeChange: (date: Date) => void;
    isDisabled: boolean;
    isFormattedTime?: boolean;
}
const useStyles = makeStyles({
    customRoot: {
        height: "25px",
        border: "0px",
        display: "flex",
        alignItems: "center",
        marginBottom: "5px",
        paddingLeft: "10px",
        paddingRight: "6px"
    },
    suffixIcon: {
        width: "16px",
        height: "16px",
        marginTop: "5px"
    },
    listbox: {
    }
});

const RXTimePicker = ({
    theme,
    value,
    bookingDate,
    defaultTime,
    onTimeChange,
    isDisabled,
    timeInterval = 15,
    isFormattedTime = true
}: RXTimePickerProps) => {
    const styles = useStyles();

    const formatDateToTimeString = (date: Date): string => {
  const hours = date.getHours();
  const minutes = date.getMinutes();

  const formattedMinutes = minutes < 10 ? "0" + minutes : minutes;

  if (isFormattedTime) {
    // ✅ 24-hour format (HH:mm)
    const formattedHours = hours < 10 ? "0" + hours : hours;
    return `${formattedHours}:${formattedMinutes}`;
  } else {
    // ✅ 12-hour format (hh:mm AM/PM)
    const ampm = hours >= 12 ? "PM" : "AM";
    const formattedHours = hours % 12 || 12;
    return `${formattedHours}:${formattedMinutes} ${ampm}`;
  }
};

    const roundedTime = moment(defaultTime)
        .startOf("minute")
        .minute(Math.round(moment(defaultTime).minute() / timeInterval) * timeInterval)
        .toDate();

    return (
        <div style={{ border: theme === "dark" ? "1px solid #525252" : "1px solid #EAEFF5", borderRadius: "3px" }}>
            <TimePicker
                className={styles.customRoot}
                disabled={isDisabled}
                expandIcon={
                    <img
                        src={`${CommonInfo.folderName}${theme === 'dark' ? '/clocklight.svg' : '/clock.svg'}`}
                        className={styles.suffixIcon}
                    />
                }
                dateAnchor={bookingDate}
                startHour={undefined}
                // defaultValue={value}
                // defaultChecked={true}
                selectedTime={roundedTime}
                increment={15}
                hourCycle={!isFormattedTime ? "h12" : "h24"}
                value={value}
                onTimeChange={(event, data) => {
                    if (data.selectedTime) {
                        onTimeChange(data.selectedTime);
                    }
                }}
                listbox={{
                    className: styles.listbox
                }}
                formatDateToTimeString={formatDateToTimeString}
            />
        </div>
    );
};


export default RXTimePicker;